import {useCustomQuery} from '@salesforce/commerce-sdk-react'
import {
    setSessionJSONItem,
    getSessionJSONItem,
    clearSessionJSONItem
} from '@salesforce/retail-react-app/app/utils/utils'

const hasValidClaraWebConfig = (config) =>
    Boolean(
        config?.default?.OrganizationId &&
            config?.default?.DeveloperName &&
            config?.default?.InitUrl &&
            config?.default?.ScriptUrl &&
            config?.default?.Url
    )

const useClaraPreferences = () => {
    const isClient = typeof window !== 'undefined'
    const cachedConfig = isClient ? getSessionJSONItem('claraConfigWeb') : null
    const cached = hasValidClaraWebConfig(cachedConfig) ? cachedConfig : null

    const {data, isLoading, error, refetch} = useCustomQuery(
        {
            options: {
                method: 'GET',
                customApiPathParameters: {
                    apiVersion: 'v1',
                    endpointPath: '/preferences?c_ids=claraConfigWeb',
                    apiName: 'preferences'
                }
            },
            rawResponse: false
        },
        {
            enabled: !cached && isClient
        }
    )

    // Parse claraConfigWeb from API response and cache it.
    let claraConfig = cached
    if (data && !cached && isClient) {
        try {
            const parsed = JSON.parse(data.claraConfigWeb || '{}')
            claraConfig = parsed
            if (hasValidClaraWebConfig(parsed)) {
                setSessionJSONItem('claraConfigWeb', parsed)
            } else {
                clearSessionJSONItem('claraConfigWeb')
                console.warn('Invalid claraConfigWeb payload for web chat:', parsed)
            }
        } catch (error) {
            console.warn('Error parsing claraConfigWeb from API:', error)
            clearSessionJSONItem('claraConfigWeb')
            claraConfig = {}
        }
    }

    return {
        claraConfig: claraConfig || {},
        isLoading: cached ? false : isLoading,
        error,
        refetch
    }
}

export {useClaraPreferences}
